"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zugentlastungJson = void 0;
const ZugentlastungMontagetyp_1 = require("./ZugentlastungMontagetyp");
exports.zugentlastungJson = {
    EntityId: '1508923396603_23002',
    Id: 350469469200,
    ArtNr: { DE: 'CF.92.52.XX.E' },
    ArtNrExists: false,
    ArtNrGenerated: 'CF.92.52..E',
    Bezeichnung: {
        'fr-FR': 'Rail en C, en inox, pour une force de retenue élevée, montage devant la chaîne port-câbles',
        'de-DE': 'C-Profil, Edelstahl, für erhöhte Haltekraft, Montage vor der e-kette',
        'en-GB': 'C-profile, stainless steel, for greater holding strength, mounting before the e-chain',
    },
    Laengeneingabe: true,
    Breite: { Unit: 'mm', Value: 1 },
    Dmin: { Unit: 'mm', Value: 0 },
    Dmax: { Unit: 'mm', Value: 0 },
    Montage: {
        '*': [
            '1400',
            '1500',
            '2400',
            '2500',
            '2450',
            '2480',
            '2600',
            '2700',
            '2650',
            '2680',
            '3400',
            '3500',
            '3450',
            '3480',
            'R117',
            'R118',
            'R157',
            'R158',
            'R167',
            'R168',
            'R48',
            'R58.New',
            'R68.New',
            'E4.21',
            'E4.28',
            'R4.28',
            'E4.32',
            'H4.32',
            'R4.32',
            'E4.42',
            'H4.42',
            'R4.42',
            'E4.56',
            'H4.56',
            'R4.56',
            'E4.80',
            'H4.80',
            'R4.80',
            'E4.112',
            'E4.162',
            '800',
            'E4.31L',
            'R4.31L',
            'E4.38L',
            'R4.38L',
            'E4.48L',
            'R4.48L',
            'E4.64L',
            '14040',
            '14140',
            'R18840',
            '14240',
            '14340',
            '14550',
            '14650',
            'R19050',
            '15050',
            '15150',
            'R19850',
            '15250',
            '15350',
            '1640',
            'R1608',
            'E61.29',
            'EF61.29',
            'E61.35',
            'E61.40',
            'E61.52',
            'E61.62',
            'E61.80',
            'E6.29',
            'R6.29',
            'E6.35',
            'E61.40',
            'E61.52',
            'E61.62',
            'E61.80',
            'E6.40',
            'E6.52',
            'R6.52',
            'E6.62',
            'E6.80L',
            'E6.80',
        ],
    },
    Montagetyp: [ZugentlastungMontagetyp_1.ZugentlastungMontagetyp.ClipsStegE456, ZugentlastungMontagetyp_1.ZugentlastungMontagetyp.KammStegE432],
};
//# sourceMappingURL=zugentlastungJson.js.map